'use strict';

class Keyvisual {

    constructor() {

        let element = document.querySelector('.keyvisual-countdown-timer');
        if (element !== null) {

            let countDownDate = new Date(element.getAttribute('data-time')).getTime();
            let timer = setInterval(function() {

                let now = new Date().getTime();

                let distance = countDownDate - now;

                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                if (distance > 0) {
                    document.querySelector('.js-get-countdown-days').innerHTML = days;
                    document.querySelector('.js-get-countdown-hours').innerHTML = hours;
                    document.querySelector('.js-get-countdown-minutes').innerHTML = minutes;
                    document.querySelector('.js-get-countdown-seconds').innerHTML = seconds;
                } else {
                    clearInterval(timer);
                    document.querySelector('.js-get-countdown-days').innerHTML = '0';
                    document.querySelector('.js-get-countdown-hours').innerHTML = '0';
                    document.querySelector('.js-get-countdown-minutes').innerHTML = '0';
                    document.querySelector('.js-get-countdown-seconds').innerHTML = '0';
                }
            }, 1000);
        }


    }

}

module.exports = Keyvisual;
